import Vue from 'vue'
import dayjs from "dayjs";

const dateFormat = (item) => {
  ['regDate', 'uptDate'].forEach((dateType) => {
    if (!item[dateType]) {
      return;
    }
    item[dateType] = dayjs(item[dateType]).format('YY/MM/DD HH:mm');
  });
}

const getUrlShareListIdx = (state, urlIdx) => {
  if (state.urlShareList.length === 0) {
    return -1;
  }

  return state.urlShareList.findIndex(item => item.urlIdx === urlIdx);
}

export default {
  SET_URLSHARE(state, urlShare) {
    dateFormat(urlShare);
    state.urlShareList.unshift(urlShare);
  },

  SET_URLSHARE_LIST(state, urlShareList = []) {
    if (urlShareList.length == 0) {
      return;
    }
    urlShareList.forEach((item) => dateFormat(item));
    state.urlShareList = urlShareList;
  },

  REMOVE_URLSHARE(state, urlIdx) {
    const idx = getUrlShareListIdx(state, urlIdx);
    if (idx > -1) {
      state.urlShareList.splice(idx, 1);
    }
  },

  UPDATE_URLSHARE(state, urlShare) {
    const idx = getUrlShareListIdx(state, urlShare.urlIdx);
    if (idx > -1) {
      dateFormat(urlShare);
      state.urlShareList.splice(idx, 1, urlShare);
    }
  },

  ADD_URLSHARE_EDIT_STATE(state, urlShare) {
    const idx = getUrlShareListIdx(state, urlShare.urlIdx);
    if (idx > -1) {
      Vue.set(state.urlShareList[idx], 'type', 'edit')
    }
  },

  REMOVE_URLSHARE_EDIT_STATE(state, urlShare = {}) {
    if (urlShare.urlIdx) {
      const idx = getUrlShareListIdx(state, urlShare.urlIdx);
      if (idx > -1) {
        Vue.delete(state.urlShareList[idx], 'type');
      }
    } else {
      const arr = state.urlShareList;
      let i = arr.length;
      while (i--) {
        const item = arr[i];
        if (!item?.urlIdx) {
          arr.splice(i, 1);
        } else {
          Vue.delete(item, 'type');
        }
      }
    }
  },

  SET_URLSHARE_HISTORY(state, event) {
    const idx = getUrlShareListIdx(state, event.data.urlIdx);
    if (idx > -1) {
      state.urlShareHistory = { sharingUserId: event.userId, ...state.urlShareList[idx] };
    }
  },

}
